import React from 'react';

function ThumbUpOutline({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
            <path
                d="M374.774 969.444h411.692c37.965 0 70.444-22.873 84.169-55.807l138.144-322.49c4.118-10.521 6.403-21.499 6.403-33.395v-91.487c0-50.319-41.168-91.487-91.487-91.487h-288.641l43.457-209.048 1.373-14.637c0-18.755-7.777-36.137-20.128-48.488l-48.489-48.031-301.447 301.45c-16.469 16.469-26.532 39.338-26.532 64.5v457.434c0 50.315 41.168 91.487 91.487 91.487zM374.774 420.524l198.528-198.528-61.296 244.27h411.69v91.487l-137.229 320.206h-411.692v-457.434zM8.827 420.524h182.974v548.922h-182.974v-548.922z"
                fill={color}
            ></path>
        </svg>
    );
}

export default ThumbUpOutline;
